import {
  FETCH_CONTACT_BLACKLIST_REQUEST,
  FETCH_CONTACT_BLACKLIST_SUCCESS,
  FETCH_CONTACT_BLACKLIST_FAILURE,
  ADD_BLACKLIST_ENTRY_REQUEST,
  ADD_BLACKLIST_ENTRY_SUCCESS,
  ADD_BLACKLIST_ENTRY_FAILURE,
  UPDATE_BLACKLIST_ENTRY_REQUEST,
  UPDATE_BLACKLIST_ENTRY_SUCCESS,
  UPDATE_BLACKLIST_ENTRY_FAILURE,
  DELETE_BLACKLIST_ENTRY_REQUEST,
  DELETE_BLACKLIST_ENTRY_SUCCESS,
  DELETE_BLACKLIST_ENTRY_FAILURE,
  FETCH_AVAILABLE_CONTACTS_REQUEST,
  FETCH_AVAILABLE_CONTACTS_SUCCESS,
  FETCH_AVAILABLE_CONTACTS_FAILURE,
  SET_BLACKLIST_FILTERS,
  CLEAR_BLACKLIST_ERROR,
  RESET_BLACKLIST_STATE
} from '../actions/types';

const initialState = {
  entries: {
    data: [],
    loading: false,
    error: null,
    pagination: {
      total: 0,
      page: 1,
      pageSize: 25,
      totalPages: 0
    }
  },
  contacts: {
    data: [],
    loading: false,
    error: null,
    searchQuery: '',
    hasMore: false
  },
  filters: {
    type: 'all',
    search: ''
  },
  operations: {
    adding: false,
    updating: false,
    deleting: false,
    error: null
  }
};

function contactBlacklistReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_CONTACT_BLACKLIST_REQUEST:
      return {
        ...state,
        entries: {
          ...state.entries,
          loading: true,
          error: null
        }
      };

    case FETCH_CONTACT_BLACKLIST_SUCCESS:
      return {
        ...state,
        entries: {
          ...state.entries,
          loading: false,
          data: payload.results || payload,
          error: null,
          pagination: {
            total: payload.count || payload.length || 0,
            page: payload.current_page || 1,
            pageSize: payload.page_size || 25,
            totalPages: payload.total_pages || Math.ceil((payload.count || 0) / (payload.page_size || 25))
          }
        }
      };

    case FETCH_CONTACT_BLACKLIST_FAILURE:
      return {
        ...state,
        entries: {
          ...state.entries,
          loading: false,
          error: payload
        }
      };

    case ADD_BLACKLIST_ENTRY_REQUEST:
      return {
        ...state,
        operations: {
          ...state.operations,
          adding: true,
          error: null
        }
      };

    case ADD_BLACKLIST_ENTRY_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          adding: false,
          error: null
        },
        entries: {
          ...state.entries,
          data: [payload, ...state.entries.data],
          pagination: {
            ...state.entries.pagination,
            total: state.entries.pagination.total + 1
          }
        }
      };

    case ADD_BLACKLIST_ENTRY_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          adding: false,
          error: payload
        }
      };

    case UPDATE_BLACKLIST_ENTRY_REQUEST:
      return {
        ...state,
        operations: {
          ...state.operations,
          updating: true,
          error: null
        }
      };

    case UPDATE_BLACKLIST_ENTRY_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          updating: false,
          error: null
        },
        entries: {
          ...state.entries,
          data: state.entries.data.map(entry =>
            entry.id === payload.id ? payload : entry
          )
        }
      };

    case UPDATE_BLACKLIST_ENTRY_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          updating: false,
          error: payload
        }
      };

    case DELETE_BLACKLIST_ENTRY_REQUEST:
      return {
        ...state,
        operations: {
          ...state.operations,
          deleting: true,
          error: null
        }
      };

    case DELETE_BLACKLIST_ENTRY_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          deleting: false,
          error: null
        },
        entries: {
          ...state.entries,
          data: state.entries.data.filter(entry => entry.id !== payload),
          pagination: {
            ...state.entries.pagination,
            total: Math.max(0, state.entries.pagination.total - 1)
          }
        }
      };

    case DELETE_BLACKLIST_ENTRY_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          deleting: false,
          error: payload
        }
      };

    case FETCH_AVAILABLE_CONTACTS_REQUEST:
      return {
        ...state,
        contacts: {
          ...state.contacts,
          loading: true,
          error: null
        }
      };

    case FETCH_AVAILABLE_CONTACTS_SUCCESS:
      return {
        ...state,
        contacts: {
          ...state.contacts,
          loading: false,
          data: payload.results || payload,
          error: null,
          hasMore: payload.next ? true : false
        }
      };

    case FETCH_AVAILABLE_CONTACTS_FAILURE:
      return {
        ...state,
        contacts: {
          ...state.contacts,
          loading: false,
          error: payload
        }
      };

    case SET_BLACKLIST_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload
        }
      };

    case CLEAR_BLACKLIST_ERROR:
      return {
        ...state,
        entries: {
          ...state.entries,
          error: null
        },
        contacts: {
          ...state.contacts,
          error: null
        },
        operations: {
          ...state.operations,
          error: null
        }
      };

    case RESET_BLACKLIST_STATE:
      return initialState;

    default:
      return state;
  }
}

export default contactBlacklistReducer;